import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Bordered panel used inside RightRail (promo, people, shortcuts, help).
 */
export default function RailPanel({ children, testId, emphasized = false, sx = {} }) {
  return (
    <Box
      data-testid={testId}
      sx={{
        p: 1.5,
        borderRadius: 2,
        border: '1px solid',
        borderColor: emphasized ? 'primary.light' : 'divider',
        bgcolor: emphasized
          ? (t) => alpha(t.palette.primary.main, 0.06)
          : 'background.paper',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

RailPanel.propTypes = {
  children: PropTypes.node,
  testId: PropTypes.string,
  emphasized: PropTypes.bool,
  sx: PropTypes.object,
};
